import React from 'react';
import { Form, Stack } from 'react-bootstrap';
import type { ClinicTO } from '../../../../../lib';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import { SectionField } from '../AdditionalSection/types';

type Value = {
  clinics: ClinicTO[];
};

interface PatientMyPathTriageCategoryProps {
  field: SectionField;
  value?: Value;
  isEditing?: boolean;
  onInputChange: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
}

const PatientMyPathTriageCategory: React.FC<
  PatientMyPathTriageCategoryProps
> = ({ field, isEditing, onInputChange }) => {
  const { patientProfile } = useSelector(
    (state: RootState) => state.patientProfile,
  );

  const { detailsValue, dateValue } = React.useMemo(() => {
    const episodeValues = patientProfile.usr_episodes_details;
    const item = episodeValues.find(
      (item) => item.name === field?.title || item.name === field?.field,
    );

    const details =
      item && 'detail' in item ? item.detail?.triage_category : undefined;
    const detailsValue = (
      Array.isArray(details) ? details.join(', ') : (details ?? '-')
    ) as string;

    const rawDate = item && 'event_date' in item ? item.event_date : undefined;
    let dateValue = '-';

    if (rawDate && rawDate !== '-') {
      try {
        const date = new Date(rawDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        dateValue = `eReferral: ${day}/${month}/${year}`;
      } catch {
        dateValue = rawDate;
      }
    }

    return { detailsValue, dateValue };
  }, [patientProfile.usr_episodes_details, field?.title]);

  return (
    <Stack
      direction="horizontal"
      gap={2}
      className="labelRow w-100"
      data-tip={dateValue}
    >
      <Form.Label className="labelBold">{field.title}</Form.Label>
      {field.editable && isEditing ? (
        <Form.Control
          as="textarea"
          rows={3}
          className="form-control-xs"
          onBlur={onInputChange}
          name={field.title}
          id={field.title}
          placeholder={field.title}
          defaultValue={detailsValue}
        />
      ) : (
        <Form.Label className="labelSimple">{detailsValue}</Form.Label>
      )}
    </Stack>
  );
};

export default PatientMyPathTriageCategory;
